'use strict';

// method to enable floating label of input field(s)
function initMaterialInputFields() {
    var inputfield = '.material-input .input-text, .material-input .input-textarea';
    
    // animate label when fields have saved date
    $(window).on('load', function() {
        $(inputfield).length && $(inputfield).each(function(){
            if($(this).val() !== '' && !$(this).hasClass('areacode')) {
                if (!$(this).closest('.material-input').find('.icon_checkmark').length) {
                    $(this).hasClass('valid') && $(this).closest('.field-wrapper').addClass('is-valid');
                    $('<i class=\'icon_checkmark\'></i>').insertBefore($(this));
                    ($(this).hasClass('phonenumber') && $(this).val().length < 4) && $(this).closest('.material-input').find('.icon_checkmark').remove();
                    $(this).hasClass('country') && $(this).closest('.material-input').find('.icon_checkmark').remove();
                }
            }
        });
        if($('.login-box-content  .material-input .input-text:-webkit-autofill').length) {
            $('<i class=\'icon_checkmark\'></i>').insertBefore('.login-box-content  .material-input .input-text');
        }
    });

    // animate label on focus-in event
    $(document).on('focusin', inputfield, function() {
        $(this).closest('.material-input').addClass('focus-in');
    });
    
    $(document).on('focus keyup', inputfield, function() {
        $(this).closest('.field-wrapper').removeClass('is-valid');
        $(this).closest('.material-input').find('.icon_checkmark').remove();
    });

    var count = 0;
    $(document).on('focusout', inputfield, function(e) {
        //reset focusin for input misbehaviour happening in modal only for first click
        if ($(this).parents('.modal-body').length && count == 0) {
            $(this).trigger('focus');
            count++;
        } else {
            if($(this).val() === '') {
                $(this).closest('.material-input').removeClass('focus-in');
            }
        }
        if ($(this).hasClass('valid')) {
            $(this).closest('.field-wrapper').addClass('is-valid');
            !$(this).closest('.material-input').find('.icon_checkmark').length && $('<i class=\'icon_checkmark\'></i>').insertBefore($(this));
        }
        if ($('.page-narspro').length && $(this).hasClass('has-value')) {
            !$(this).closest('.material-input').find('.icon_checkmark').length && $('<i class=\'icon_checkmark\'></i>').insertBefore($(this));
        }
        ($(this).hasClass('phonenumber') && $(this).val().length < 4) && $(this).closest('.material-input').find('.icon_checkmark').remove();
        if (
            $(this).hasClass('error') || 
            ($(this).hasClass('address2') && !$(this).val()) || 
            ($(this).hasClass('lastname2') && !$(this).val()) ||
            ($(this).hasClass('birthyear') && !$(this).val())
        ) {
            $(this).closest('.field-wrapper').removeClass('is-valid');
            $(this).closest('.material-input').find('.icon_checkmark').remove();
        }
    });

    $('.edit-modal .close-button, .reveal-overlay').on('click', function (e) {
        if($(e.target).hasClass('reveal-overlay') || $(e.target).hasClass('icon-close')) {
            count = 0;
        }
    });

    // reset checkout billing address form
    if($('#same-as-shipping').length) {
        $(document).on('change', '#same-as-shipping', function() {
            $(inputfield).length && $(inputfield).each(function(){
                $(this).closest('.material-input').removeClass('focus-in');
                if($(this).val() !== '' && !$(this).hasClass('areacode')) {
                    $(this).closest('.material-input').addClass('focus-in');
                }
            });
        });
    }    
}

function setEditMaterialFields() {
    var isRendered = null;
    if(isRendered){
        clearTimeout(isRendered);
    }
    isRendered = setTimeout(function() {
        var $materialFields = $(document).find('.address-dialog-wrapper .material-input .input-text, .edit-add-address .material-input .input-text, .edit-add-address .material-input .input-textarea, .edit_address_form .material-input .input-text, .checkout-shipping .material-input .input-text');
        $materialFields.length && $materialFields.each(function(){
            if($(this).val() !== '' && !$(this).hasClass('areacode')) {
                $(this).closest('.material-input').addClass('focus-in');
                if (!$(this).closest('.material-input').find('.icon_checkmark').length) {
                    $(this).hasClass('valid') && $(this).closest('.field-wrapper').addClass('is-valid');
                    $('<i class=\'icon_checkmark\'></i>').insertBefore($(this));
                    ($(this).hasClass('phonenumber') && $(this).val().length < 4) && $(this).closest('.material-input').find('.icon_checkmark').remove();
                    $(this).hasClass('country') && $(this).closest('.material-input').find('.icon_checkmark').remove();
                }
            }
        });
    }, 1000);
}

export default {
    init : function() {
        initMaterialInputFields(); // material input init
    },
    setEditMaterialFields: setEditMaterialFields
}
